export const GREY = '#9B9B9B';
export const BLUE = '#00ADE2';
export const WHITE = '#FFFFFF';
export const ENABLED_GREY = '#4A4A4A';
export const DISABLED_GREY = '#C9C9C9';
